(function () {
  if (window.__spdpDiscountBannerDateInited) return;
  window.__spdpDiscountBannerDateInited = true;

  var MONTHS =
    'janvier|f[eé]vrier|fevrier|mars|avril|mai|juin|juillet|ao[uû]t|aout|septembre|octobre|novembre|d[eé]cembre|decembre|' +
    'january|february|march|april|may|june|july|august|september|october|november|december|' +
    'januar|j[aä]nner|februar|m[aä]rz|maerz|april|mai|juni|juli|august|september|oktober|november|dezember';

  var DATE_RE = new RegExp('\\d{1,2}\\.\\s*(?:' + MONTHS + ')\\b|\\d{1,2}\\s+(?:' + MONTHS + ')\\b', 'i');

  function refreshDiscountBannerDates() {
    document.querySelectorAll('[data-spdp-discount-banner-text]').forEach(function (el) {
      var raw = el.textContent || '';
      if (!DATE_RE.test(raw)) return;
      var lang = document.documentElement.lang || 'en';
      var today = new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'long' }).format(new Date());
      el.textContent = raw.replace(DATE_RE, today);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshDiscountBannerDates);
  } else {
    refreshDiscountBannerDates();
  }

  document.addEventListener('shopify:section:load', refreshDiscountBannerDates);
})();
